import { useMemo } from 'react';
import { TextField } from '@mui/material';
import type { SpecField } from '../grid/types/specificationTypes';

type SpecFieldEditorProps = {
  field: SpecField;
  value: string;
  onChange: (value: string) => void;
};

export const SpecFieldEditor = ({ field, value, onChange }: SpecFieldEditorProps) => {
  const isNumber = field.dataType?.toLowerCase() === 'number' || field.editor === 'dxNumberBox';

  const step = useMemo(() => {
    if (!isNumber || !field.format) return undefined;
    const decimals = (field.format.match(/#+$/)?.[0] ?? '').length;
    return decimals > 0 ? Math.pow(10, -decimals) : 1;
  }, [isNumber, field.format]);

  return (
    <TextField
      size="small"
      fullWidth
      type={isNumber ? 'number' : 'text'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={field.allowEditing === false}
      required={field.isRequired}
      inputProps={step !== undefined ? { step } : undefined}
    />
  );
};
